import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import template from './index.jade';
import css from './index.inline.styl';

export class CustomEventComposition extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'composition-parts': `json`,
    };
  }

  get config() {
    return {
      template,
      css,
      useShadowDom: true,
    };
  }
}

export const CustomEventCompositionEl = defineAndMakeJsxFactory(`mp-custom-event-composition`, CustomEventComposition);
export const CustomEventCompositionReact = panel2react(`mp-custom-event-composition`, CustomEventComposition);
